import { Input, Spin } from 'antd'
import RadioButton from 'components/Form/Radio'
import TextAreas from 'components/Form/TextArea'
import RichEditor from 'components/RichEditor/RoundRichText.js'
import Select, { FormItem } from 'components/Select'
import { FormHeading } from 'components/UIComponents/FormStyles'
import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react'
import CtcSelect from '../../../../../../components/CtcSelect'
import Checkbox from '../../../../../../components/Form/Checkbox'
import { RadioGroups } from '../../../../../../components/UIComponents/FormStyles'
import { isReturnBoolean } from '../../../../../../utils/rolecreationHelpers'
import { LabelDiv } from '../JobDetails/style'
import { SelectInputDivision, TierInputNumber, ToDiv, Wrapper } from './style'
const { COUNTRY_ID } = process.env

const StipendDetails = ({
  setRoleFormData,
  roleFormData,
  getListOfCities,
  key,
  setSave,
  roleForm,
  eligibleCandidatesMetrics,
  setQualificationError,
  current,
  draft,
  jobStipendForm,
  searchCities,
  stepStatus,
  triggerBack,
  setPreviewData,
  previewData,
  getLocations,
}) => {
  // Initialize showRange from roleFormData to persist state when navigating
  const [showRange, setShowRange] = useState(() => {
    return roleFormData?.ctc?.isRange || false;
  });
  const selectedType = roleFormData?.jobDetails?.jobCategory
  const [loadLocation, setLoadLocation] = useState(false)
  const [citiesList, setCitiesList] = useState([])
  const [notFoundedCityList, setNotFoundedCityList] = useState([])

  const getCities = async text => {
    let list = await getLocations(text)

    const newOptions = [
      ...list.cities.map(city => ({
        value: city.city_id,
        name: city.city_name,

        type: 'city',
        payload: {
          id: city.city_id,
          name: city.city_name,
          state_id: city.state_id,
          state_name: city.state_name,
        },
      })),
      ...list.states.map(state => ({
        value: state.state_id,
        name: state.state_name,
        type: 'state',
        payload: {
          state_id: state.state_id,
          state_name: state.state_name,
        },
      })),
    ]

    setCitiesList(newOptions)
    setLoadLocation(false)
  }

  function debounce(fn, delay) {
    let timer
    return function () {
      let context = this,
        args = arguments
      clearTimeout(timer)
      timer = setTimeout(() => {
        fn.apply(context, args)
      }, delay)
    }
  }
  const delaySaveToDb = useCallback(
    debounce(text => {
      getCities(text)
    }, 1000),
    []
  )

  useEffect(() => {
    if (current == 1) {
      setLoadLocation(true)
      getCities()
    }
  }, [current])
  const RadioOptions1 = [
    {
      id: 1,
      label: 'Annually',
      value: 'ANNUALLY',
    },
    {
      id: 2,
      label: 'Monthly',
      value: 'MONTHLY',
    },
  ]
  // const locationHandler = (selectedValues, selectedOptions) => {
  //   const selectedPayloads = selectedOptions?.map(item => item.option)

  //   form.setFieldsValue({
  //     preferredJobLocation: selectedPayloads,
  //   })
  //   setLocations(selectedPayloads)
  // }

  const onLocationChange = (value, key, options) => {
    setSave(false)
    delaySaveToDb('')
    if (key == 'remotCities' || key == 'cities') {
      setRoleFormData({
        ...roleFormData,
        jobLocation: {
          ...roleFormData?.jobLocation,
          [key]: options?.map(item => item?.option),
          [key + 'Ids']: value,
        },
      })
      previewData.cities = options?.map(item => item?.option)
      let data = {
        ...roleFormData,
        jobLocation: {
          ...roleFormData?.jobLocation,
          [key]: options?.map(item => item?.option),
          [key + 'Ids']: value,
        },
      }
      setNotFoundedCityList([])
      eligibleCandidatesMetrics(data)
    } else {
      if (!roleFormData.jobLocation.isAnyWhere && key == 'isAnyWhere') {
        roleFormData.jobLocation.isAnyWhere = true
        previewData.cities = []
        previewData.isAnyWhere = true
      }
      setRoleFormData({
        ...roleFormData,
        jobLocation: {
          ...roleFormData?.jobLocation,
          [key]: value,
        },
      })
      setNotFoundedCityList([])
    }
  }
  const handleCheckboxChange = event => {
    setSave(false)
    onLocationChange(event.target.checked, 'isAnyWhere')
    let data = {
      ...roleFormData,
      jobLocation: {
        ...roleFormData?.jobLocation,
        isAnyWhere: event.target?.checked,
      },
    }
    eligibleCandidatesMetrics(data)
  }

  const onChangeHandlerCTC = (value, key) => {
    setSave(false);
    
    // Block any 0 values immediately
    if ((key === 'min' || key === 'max') && (value === 0 || value === '0')) {
      return;
    }

    // Handle range checkbox - completely isolated
    if (key === 'isRange') {
      setShowRange(value);
      
      // Update form data
      setRoleFormData(prev => ({
        ...prev,
        ctc: {
          ...prev.ctc,
          isRange: value,
          max: value ? prev.ctc.max : ''
        }
      }));

      // Clear max field when unchecking
      if (!value) {
        roleForm?.setFieldValue(['ctc', 'max'], '');
        roleForm?.setFieldValue(['ctc', 'max'], undefined);
        // Force clear from roleFormData immediately
        setRoleFormData(prev => ({
          ...prev,
          ctc: {
            ...prev.ctc,
            max: '',
            isRange: false
          }
        }));
      }

      // Update preview - clear max when range is disabled
      setPreviewData(prev => ({
        ...prev,
        minCompensation: roleFormData?.ctc?.min ?? '',
        maxCompensation: value ? (roleFormData?.ctc?.max ?? '') : null
      }));
      return;
    }

    // Handle the case when min is being set to 0 or empty
    if (key === 'min' && (value === '' || value === null || value === undefined || value === 0)) {
      setRoleFormData(prev => ({
        ...prev,
        ctc: {
          ...prev.ctc,
          [key]: '', // Set to empty string for API compatibility
        },
      }));
      
      // Also update preview data
      setPreviewData(prev => ({
        ...prev,
        minCompensation: '',
        maxCompensation: prev.maxCompensation // Keep max as is
      }));
      return;
    }

    // Handle max CTC changes - only allow if range is enabled
    if (key === 'max') {
      // Block max updates if range is not enabled
      if (!showRange) {
        return;
      }

      // Handle max being set to 0 or empty
      if (value === '' || value === null || value === undefined) {
        setRoleFormData(prev => ({
          ...prev,
          ctc: {
            ...prev.ctc,
            [key]: null, // Set to null to exclude from API payload
          },
        }));
        
        // Also update preview data
        setPreviewData(prev => ({
          ...prev,
          maxCompensation: null
        }));
        return;
      }

      // Normal max value update (only when range is enabled)
      setRoleFormData(prev => ({
        ...prev,
        ctc: {
          ...prev.ctc,
          [key]: value,
        }
      }));

      // Update preview data for max
      setPreviewData(prevState => {
        const newState = { ...prevState };
        if (showRange) {
          newState.maxCompensation = value;
        }
        return newState;
      });

      // Only set form field value if not trying to set max when range is disabled
    if (!(key === 'max' && !showRange)) {
      roleForm?.setFieldValue(['ctc', key], value);
    }
      return;
    }

    // For all other cases, update normally but block max if range is disabled
    let updatedCTC = {
      ...roleFormData.ctc,
      [key]: value,
    };

    // If user edits min when range is OFF, always clear any old max value
    // This prevents cases like duplicate roles where a previous max (e.g. 8000)
    // would still be carried and shown as a range (e.g. 9000 - 8000) in preview
    if (key === 'min' && !roleFormData?.ctc?.isRange) {
      updatedCTC.max = null;
    }

    // Additional safety: if trying to set max when range is disabled, block it
    if (key === 'max' && !showRange) {
      return;
    }

    setRoleFormData({
      ...roleFormData,
      ctc: updatedCTC,
    });
    if (key == 'isNoStipend') {
      
      setPreviewData(prevState => ({
        ...prevState,
        stipend: false, 
        min: null,
        max: null,
        minCompensation: value === false ? 0 : prevState.minCompensation,
        maxCompensation: value === false ? 0 : prevState.maxCompensation,
      }))
        setRoleFormData(prevState => ({
    ...prevState,
    ctc: {
      ...prevState.ctc,
      min: null,
      max: null,
    },
  }));
  return;
    } else if (key == 'period') {
      setPreviewData(prevState => ({
        ...prevState,
        CTCPeriod: value,
      }))
    } else if (key === 'isRange' || key === 'min' || key === 'max') {
      setPreviewData(prevState => {
        const newState = { ...prevState };
        
        if (key === 'isRange') {
          if (value) {
            // Show Range is checked - show both min and max values
            newState.minCompensation = roleFormData?.ctc?.min ?? '';
            newState.maxCompensation = roleFormData?.ctc?.max ?? '';
          } else {
            // Show Range is unchecked - clear max and show only min value
            newState.minCompensation = roleFormData?.ctc?.min ?? '';
            newState.maxCompensation = null;
          }
        } else if (key === 'min') {
          // When min value changes, update min but preserve max if range is enabled
          newState.minCompensation = value ?? '';
          // Only clear max if range is NOT enabled
          if (!roleFormData?.ctc?.isRange) {
            newState.maxCompensation = null;
          }
        } else if (key === 'max') {
          // Only update max if range is enabled
          if (showRange) {
            newState.maxCompensation = value ?? '';
            // Keep existing min value
            newState.minCompensation = prevState.minCompensation;
          } else {
            // If range is disabled, ignore max updates and clear max compensation
            newState.maxCompensation = null;
            return prevState; // Don't update anything if range is disabled
          }
        }
        return newState;
      });
    } else {
      setPreviewData(prevState => ({
        ...prevState,
        [key]: value,
      }))
    }
  }
  const options = [
    {
      label: 'Fixed',
      value: 'FIXED',
    },
    {
      label: 'Fixed + Variable',
      value: 'FIXED_VARIABLE',
    },
  ]
  useEffect(() => {
    setQualificationError('')
    setLoadLocation(true)
    getCities('')
  }, [])

  useEffect(() => {
    if (draft) {
      roleForm.setFields([
        {
          name: ['ctc', 'max'],
          errors: [''],
        },
      ])
    }
  }, [draft])
  const parseStipendData = async jobStipendForm => {
    if (jobStipendForm) {
      if (
        jobStipendForm?.CTCPeriod &&
        (roleFormData?.jobDetails?.jobCategory == 'PLACEMENT' ||
          roleFormData?.jobDetails?.jobCategory == 'GIGS' ||
          roleFormData?.jobDetails?.jobCategory == 'APPRENTICESHIP')
      ) {
        const monthlyValueData = ['MONTHLY', 'PER MONTH', 'MONTH', 'MON', 'PM']
        const formatedValue = monthlyValueData.includes(
          jobStipendForm?.CTCPeriod?.toUpperCase()
        )
          ? 'MONTHLY'
          : 'ANNUALLY'
        roleFormData.ctc.period = formatedValue
        roleForm.setFieldValue(['ctc', 'period'], formatedValue)
      } else if (roleFormData?.jobDetails?.jobCategory == 'INTERNSHIP') {
        roleFormData.ctc.period = 'MONTHLY'
        roleForm.setFieldValue(['ctc', 'period'], 'MONTHLY')
      }
      let minCtcValue
      let maxCtcValue
      if (jobStipendForm?.minCtc || jobStipendForm?.maxCtc) {
        minCtcValue = jobStipendForm?.minCtc
          ? jobStipendForm.minCtc.replace(/,/g, '')
          : '0'
        maxCtcValue = jobStipendForm?.maxCtc
          ? jobStipendForm.maxCtc.replace(/,/g, '')
          : '0'
      }
      if (
        roleFormData?.jobDetails?.jobCategory == 'PLACEMENT' ||
        roleFormData?.jobDetails?.jobCategory == 'GIGS'
      ) {
        // bond details
        if (jobStipendForm?.isBond != 0) {
          const formatedValue = jobStipendForm.isBond == 1 ? true : false
          roleFormData.ctc.isBond = formatedValue
          roleForm.setFieldValue(['ctc', 'isBond'], formatedValue)
          if (jobStipendForm?.bondType && formatedValue) {
            roleFormData.ctc.bondType = jobStipendForm?.bondType
            roleForm.setFieldValue(
              ['ctc', 'bondType'],
              jobStipendForm?.bondType
            )
          } else {
            roleFormData.ctc.bondType = ''
            roleForm.setFieldValue(['ctc', 'bondType'], '')
          }
        }
        if (
          (minCtcValue && Number(minCtcValue) != NaN) ||
          (maxCtcValue && Number(maxCtcValue) != NaN)
        ) {
          const ctcValue = Number(minCtcValue) || Number(maxCtcValue)
          if (ctcValue && ctcValue > 0) {
            roleFormData.ctc.min = ctcValue
            roleForm.setFieldValue(['ctc', 'min'], ctcValue)
          } else {
            roleFormData.ctc.min = ''
            roleForm.setFieldValue(['ctc', 'min'], '')
          }
          roleFormData.ctc.max = ''
          roleForm.setFieldValue(['ctc', 'max'], '')
          roleFormData.ctc.isRange = false
          roleForm.setFieldValue(['ctc', 'isRange'], false)
        }
        // ctc type
        if (jobStipendForm?.['isFixed+VariableSalary'] === 1) {
          roleFormData.ctc.ctcType = 'FIXED_VARIABLE'
          roleForm.setFieldValue(['ctc', 'ctcType'], 'FIXED_VARIABLE')
        }
        if (jobStipendForm?.isFixedSalary === 1) {
          roleFormData.ctc.ctcType = 'FIXED'
          roleForm.setFieldValue(['ctc', 'ctcType'], 'FIXED')
        }
      }

      if (jobStipendForm?.additionalBenefits) {
        const formatedValue = Array.isArray(jobStipendForm?.additionalBenefits)
          ? jobStipendForm?.additionalBenefits?.length
            ? true
            : false
          : jobStipendForm?.additionalBenefits
          ? true
          : false

        roleFormData.ctc.isAdditional = formatedValue
        roleForm.setFieldValue(['ctc', 'isAdditional'], formatedValue)
        if (formatedValue) {
          const additionalBenefitsValue = jobStipendForm?.additionalBenefits
          let newAdditionalBenefitsValue = ''

          // Check if the job description is an array
          if (Array.isArray(additionalBenefitsValue)) {
            newAdditionalBenefitsValue =
              '<ul>' +
              additionalBenefitsValue.map(item => `<li>${item}</li>`).join('') +
              '</ul>'
          }
          // Check if the job description is a string
          else if (typeof additionalBenefitsValue === 'string') {
            newAdditionalBenefitsValue = `<p>${additionalBenefitsValue}</p>`
          }
          // Check if the job description is an object
          else if (
            typeof additionalBenefitsValue === 'object' &&
            additionalBenefitsValue !== null
          ) {
            newAdditionalBenefitsValue = Object.entries(additionalBenefitsValue)
              .map(([sectionTitle, items]) => {
                if (Array.isArray(items)) {
                  return (
                    `<h3>${sectionTitle}:</h3><ul>` +
                    items.map(item => `<li>${item}</li>`).join('') +
                    `</ul>`
                  )
                } else if (typeof items === 'string') {
                  return `<h3>${sectionTitle}:</h3><p>${items}</p>`
                } else if (typeof items === 'object' && items !== null) {
                  return `<h3>${sectionTitle}:</h3><pre>${JSON.stringify(
                    items,
                    null,
                    2
                  )}</pre>`
                }
                return ''
              })
              .join('\n')
          }

          roleFormData.ctc.additionalBenefits = newAdditionalBenefitsValue
          roleForm.setFieldValue(
            ['ctc', 'additionalBenefits'],
            newAdditionalBenefitsValue
          )
        }
      }

      if (
        (roleFormData?.jobDetails?.jobCategory == 'INTERNSHIP' ||
          roleFormData?.jobDetails?.jobCategory == 'APPRENTICESHIP') &&
        jobStipendForm?.stipend != 0
      ) {
        minCtcValue = jobStipendForm?.internship_StipendValue?.[0]
          ? jobStipendForm?.internship_StipendValue?.[0].replace(/,/g, '')
          : jobStipendForm?.apprenticeship_StipendValue?.[1]
          ? jobStipendForm?.apprenticeship_StipendValue?.[1].replace(/,/g, '')
          : jobStipendForm?.minCtc
          ? jobStipendForm.minCtc.replace(/,/g, '')
          : '0'
        maxCtcValue = jobStipendForm?.internship_StipendValue?.[1]
          ? jobStipendForm?.internship_StipendValue?.[1].replace(/,/g, '')
          : jobStipendForm?.apprenticeship_StipendValue?.[1]
          ? jobStipendForm?.apprenticeship_StipendValue?.[1].replace(/,/g, '')
          : jobStipendForm?.maxCtc
          ? jobStipendForm.maxCtc.replace(/,/g, '')
          : '0'

        if (
          (minCtcValue && Number(minCtcValue) != NaN) ||
          (maxCtcValue && Number(maxCtcValue) != NaN)
        ) {
          roleFormData.ctc.isNoStipend = true
          roleForm.setFieldValue(['ctc', 'isNoStipend'], true)
          const stipendValue = Number(minCtcValue) || Number(maxCtcValue)
          if (stipendValue && stipendValue > 0) {
            roleFormData.ctc.min = stipendValue
            roleForm.setFieldValue(['ctc', 'min'], stipendValue)
          } else {
            roleFormData.ctc.min = ''
            roleForm.setFieldValue(['ctc', 'min'], '')
          }
        }
      }

      if (jobStipendForm?.isAnyWhere == 1) {
        roleFormData.jobLocation.isAnyWhere = true
        roleForm.setFieldValue(['jobLocation', 'isAnyWhere'], true)
      }
      let citiesArray = []
      if (typeof jobStipendForm?.Cities === 'string') {
        citiesArray = jobStipendForm.Cities.split(',').map(city => city.trim())
      } else if (Array.isArray(jobStipendForm?.Cities)) {
        citiesArray = jobStipendForm?.Cities
      }
      if (citiesArray?.length && jobStipendForm?.isAnyWhere == 0) {
        setLoadLocation(true)
        const foundedCityList = []
        const notFoundCityList = []
        const foundedCityIdsList = []
        for (const city of citiesArray) {
          const parsedCities = await getLocations(city)
          if (parsedCities?.states?.length || parsedCities?.cities?.length) {
            const newOptions = [
              ...parsedCities.cities.map(city => ({
                value: city.city_id,
                name: city.city_name,

                type: 'city',
                payload: {
                  id: city.city_id,
                  name: city.city_name,
                  state_id: city.state_id,
                  state_name: city.state_name,
                },
              })),
              ...parsedCities.states.map(state => ({
                value: state.state_id,
                name: state.state_name,
                type: 'state',
                payload: {
                  state_id: state.state_id,
                  state_name: state.state_name,
                },
              })),
            ]
            foundedCityList.push(newOptions?.[0])
            foundedCityIdsList.push(
              parsedCities?.cities?.[0]?.city_id ??
                parsedCities?.states?.[0]?.state_id
            )
          } else {
            notFoundCityList.push(city)
          }
        }
        roleFormData.jobLocation.cities = foundedCityList || []
        roleForm.setFieldValue(['jobLocation', 'cities'], foundedCityList || [])
        roleFormData.jobLocation.citiesIds = foundedCityIdsList || []
        roleForm.setFieldValue(
          ['jobLocation', 'citiesIds'],
          foundedCityIdsList || []
        )
        setNotFoundedCityList(notFoundCityList)
        await getCities('')
        setLoadLocation(false)
      }
    }
  }
  useLayoutEffect(() => {
    if (jobStipendForm && !stepStatus?.ctc && !triggerBack) {
      parseStipendData(jobStipendForm)
    }
  }, [jobStipendForm])

  // Sync showRange state with roleFormData when navigating to CTC page
  useLayoutEffect(() => {
    if (current === 1) {
      // Restore showRange state from roleFormData if it exists
      const savedIsRange = roleFormData?.ctc?.isRange;
      if (savedIsRange !== undefined) {
        setShowRange(savedIsRange);
      }
      
      // Only clear fields if this is a truly new role (no existing CTC data)
      if (!roleFormData?.ctc?.min && !roleFormData?.ctc?.max) {
        if (roleForm) {
          roleForm.setFieldValue(['ctc', 'max'], undefined);
          roleForm.setFieldValue(['ctc', 'min'], undefined);
        }
      }
    }
    
    // Sync previewData when leaving CTC page (going to preview or other pages)
    if (current !== 1 && roleFormData?.ctc) {
      
      // If "No Stipend" is checked (isNoStipend is false), set compensation to 0
      const shouldClearCompensation = roleFormData?.ctc?.isNoStipend === false;
      
      setPreviewData(prev => {
        const newData = {
          ...prev,
          minCompensation: shouldClearCompensation ? 0 : (roleFormData?.ctc?.min ?? ''),
          maxCompensation: shouldClearCompensation ? 0 : (roleFormData?.ctc?.isRange ? (roleFormData?.ctc?.max ?? '') : null),
          stipend: shouldClearCompensation ? false : prev.stipend
        };
        
        console.log('✅ Setting preview data to:', {
          minCompensation: newData.minCompensation,
          maxCompensation: newData.maxCompensation,
          stipend: newData.stipend
        });
        
        return newData;
      });
    }
  }, [current])


  return (
    <>
      <FormHeading>
        {selectedType == 'INTERNSHIP' || selectedType == 'APPRENTICESHIP'
          ? 'Stipend & Job Location'
          : 'CTC & Job Location'}
      </FormHeading>
      {selectedType != 'INTERNSHIP' && selectedType !== 'APPRENTICESHIP' && (
        <>
          <LabelDiv>Select Period *</LabelDiv>
          <FormItem
            name={['ctc', 'period']}
            rules={[
              {
                required: true, // Check the flag
                message: 'Please select any one period',
              },
            ]}
          >
            <RadioGroups
              onChange={({ target }) => {
                onChangeHandlerCTC(target.value, 'period')
              }}
            >
              {RadioOptions1?.map((item, index) => (
                <RadioButton
                  key={index + item?.value}
                  border={true}
                  label={item?.label}
                  value={item?.value}
                  disabled={isReturnBoolean(
                    roleFormData?.roleStatus,
                    undefined,
                    roleFormData?.republishedDate
                  )}
                />
              ))}
            </RadioGroups>
          </FormItem>
        </>
      )}
      {selectedType == 'APPRENTICESHIP' && roleFormData?.ctc?.isNoStipend && (
        <>
          <LabelDiv>Select Period *</LabelDiv>
          <FormItem
            name={['ctc', 'period']}
            rules={[
              {
                required: true, // Check the flag
                message: 'Please select any one period',
              },
            ]}
          >
            <RadioGroups
              onChange={({ target }) => {
                onChangeHandlerCTC(target.value, 'period')
              }}
            >
              {RadioOptions1?.map((item, index) => (
                <RadioButton
                  key={index + item?.value}
                  border={true}
                  label={item?.label}
                  value={item?.value}
                  disabled={isReturnBoolean(
                    roleFormData?.roleStatus,
                    undefined,
                    roleFormData?.republishedDate
                  )}
                />
              ))}
            </RadioGroups>
          </FormItem>
        </>
      )}
      <>
        <>
          {selectedType == 'INTERNSHIP' ||
          (selectedType == 'APPRENTICESHIP' &&
            !roleFormData?.ctc?.isNoStipend) ? (
            ''
          ) : (
            <div
              style={{
                display: 'flex',
                marginBottom: '-1rem',
                justifyContent: 'center',
                alignItems: 'baseline',
              }}
            >
              <LabelDiv>
                {selectedType == 'APPRENTICESHIP' &&
                roleFormData?.ctc?.period === 'MONTHLY'
                  ? 'Monthly Stipend *'
                  : selectedType == 'APPRENTICESHIP'
                  ? 'Stipend*'
                  : 'CTC *'}
              </LabelDiv>
          
              {selectedType == 'APPRENTICESHIP' ? <br /> : (
                <FormItem
                  name={['ctc', 'isRange']}
                  rules={[
                    {
                      required: false,
                      message: 'Please select range',
                    },
                  ]}
                  style={{
                    display: 'flex',
                    justifyContent: 'end',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <Checkbox
                    onChange={event =>
                      onChangeHandlerCTC(event.target.checked, 'isRange')
                    }
                    label={'Show Range'}
                    checked={showRange}
                    disabled={isReturnBoolean(
                      roleFormData?.roleStatus,
                      undefined,
                      roleFormData?.republishedDate
                    )}
                  />
                </FormItem>
              )}
            </div>
          )}
        </>
        {selectedType == 'INTERNSHIP' &&
        !roleFormData?.ctc?.isNoStipend ? null : selectedType ==
          'INTERNSHIP' ? (
          <LabelDiv style={{ marginBottom: '-13px' }}>
            {selectedType == 'INTERNSHIP' ? 'Monthly Stipend *' : 'CTC *'}
          </LabelDiv>
        ) : null}
        {(selectedType == 'INTERNSHIP' && !roleFormData?.ctc?.isNoStipend) ||
        (selectedType == 'APPRENTICESHIP' &&
          !roleFormData?.ctc?.isNoStipend) ? null : (
          <SelectInputDivision
            width="100%"
            borderleft={true}
            marginbottom={'15px'}
          >
            <CtcSelect
              bordered={false}
              defaultValue={'INR ₹'}
              disabled={true}
              filterOption={false}
              width="25%"
              style={{
                color: '#808697',
                fontSize: 'small',
              }}
            />
            <FormItem
              name={['ctc', 'min']}
              initialValue={undefined}
              rules={[
                {
                  validator(_, value) {
                    // Ensure the value is trimmed and converted to a number
                    const valueString =
                      typeof value === 'string' || typeof value === 'number'
                        ? String(value).trim()
                        : ''
                    const valueNumber = Number(valueString.replace(/,/g, ''))

                    // Handle the required field validation
                    if (!draft && (!value || valueString === '')) {
                      return Promise.reject(new Error(`Please enter ${selectedType == 'APPRENTICESHIP' || selectedType == 'INTERNSHIP' ? 'Stipend' : 'CTC'} value`))
                    }

                    if (isNaN(valueNumber)) {
                      return Promise.reject(    
                        new Error(`Please enter a valid ${selectedType == 'APPRENTICESHIP' || selectedType == 'INTERNSHIP' ? 'Stipend' : 'CTC'}`)
                      )
                    }

                    if (valueNumber <= 0 && !draft) {
                      return Promise.reject(
                        new Error(`Please enter a valid ${selectedType == 'APPRENTICESHIP' || selectedType == 'INTERNSHIP' ? 'Stipend' : 'CTC'}`)
                      )
                    }

                    if (valueNumber > 20000000) {
                      return Promise.reject(
                        new Error(
                          'Value must be lesser than or equal to 2 crores'
                        )
                      )
                    }

                    const max = roleForm?.getFieldValue(['ctc', 'max'])
                    const maxString =
                      typeof max === 'string' || typeof max === 'number'
                        ? String(max).trim()
                        : ''
                    const maxNumber = Number(maxString.replace(/,/g, ''))

                    if (isNaN(maxNumber)) {
                      return Promise.reject(
                        new Error('Maximum CTC value is not valid.')
                      )
                    }

                    if (valueNumber > maxNumber && roleFormData?.ctc?.isRange) {
                      return Promise.reject(
                        new Error('Please enter a valid CTC')
                      )
                    }

                    return Promise.resolve()
                  },
                },
              ]}
            >
              <div style={{ display: 'flex' }}>
                <TierInputNumber
                  width="50%"
                  height="40px"
                  borderRadius={'0 8px 8px 0'}
                  onChange={e => {
                    if (e === 0 || e === '0') {
                      return;
                    }
                    onChangeHandlerCTC(e, 'min')
                  }}
                  value={(() => {
                    const minValue = roleFormData?.ctc?.min;
                    // Never show 0, null, undefined, or empty string
                    if (!minValue || minValue === 0 || minValue === '0' || minValue === '') {
                      return undefined;
                    }
                    return minValue;
                  })()}
                  formatter={value =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  }
                  placeholder="10,00,000"
                  parser={value => value.replace(/\$\s?|,/g, '')}
                  disabled={isReturnBoolean(
                    roleFormData?.roleStatus,
                    undefined,
                    roleFormData?.republishedDate
                  )}
                />
                {showRange && <ToDiv>To</ToDiv>}
              </div>
            </FormItem>
          </SelectInputDivision>
        )}
      </>
      {showRange && (
        <Wrapper>
          <SelectInputDivision
            width="100%"
            borderleft={true}
            marginbottom={'15px'}
          >
            <CtcSelect
              bordered={false}
              defaultValue={'INR ₹'}
              disabled={true}
              filterOption={false}
              width="25%"
              style={{
                color: '#808697',
                fontSize: 'small',
              }}
            />
            <FormItem
              name={['ctc', 'max']}
              initialValue={undefined}
              rules={[
                {
                  validator: (_, value) => {
                    // Skip validation if range is not enabled
                    if (!showRange) {
                      return Promise.resolve()
                    }

                    const min = roleForm?.getFieldValue(['ctc', 'min'])

                    const minString = min ? String(min) : ''
                    const minNumber = Number(minString.replace(/,/g, ''))

                    const valueString = value ? String(value) : ''
                    const valueNumber = Number(valueString.replace(/,/g, ''))

                    if (isNaN(minNumber)) {
                      return Promise.reject(
                        new Error('Minimum CTC value is not valid.')
                      )
                    }

                    if (isNaN(valueNumber) || valueNumber <= 0) {
                      return Promise.reject(new Error('Please enter the CTC'))
                    }
                    if (valueNumber > 20000000) {
                      return Promise.reject(
                        new Error(
                          'Value must be lesser than or equal to 2 crores'
                        )
                      )
                    }
                    if (valueNumber < minNumber && showRange) {
                      return Promise.reject(
                        new Error('Please enter a valid CTC')
                      )
                    }
                    return Promise.resolve()
                  },
                },
              ]}
            >
              <div>
                <TierInputNumber
                  width="100%"
                  height="40px"
                  borderRadius={'0 8px 8px 0'}
                  formatter={value =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  }
                  onChange={e => {
                    if (!showRange || e === 0 || e === '0') {
                      return;
                    }
                    onChangeHandlerCTC(e, 'max')
                    roleForm?.validateFields([['ctc', 'min']])
                  }}
                  placeholder="10,00,000"
                  value={(() => {
                    if (!showRange) return undefined;
                    const maxValue = roleFormData?.ctc?.max;
                    // Never show 0, null, undefined, or empty string
                    if (!maxValue || maxValue === 0 || maxValue === '0' || maxValue === '') {
                      return undefined;
                    }
                    return maxValue;
                  })()}
                  parser={value => value.replace(/\$\s?|,/g, '')}
                  disabled={isReturnBoolean(
                    roleFormData?.roleStatus,
                    undefined,
                    roleFormData?.republishedDate
                  )}
                />
              </div>
            </FormItem>
          </SelectInputDivision>
        </Wrapper>
      )}
      {(selectedType == 'INTERNSHIP' || selectedType == 'APPRENTICESHIP') && (
        <FormItem
          name={['ctc', 'isNoStipend']}
          rules={[
            {
              required: false, // Check the flag
              message: 'Please select range',
            },
          ]}
        >
          <Checkbox
            name={['ctc', 'isNoStipend']}
            onChange={event =>
              onChangeHandlerCTC(!event.target.checked, 'isNoStipend')
            }
            label={'No Stipend'}
            checked={!roleFormData?.ctc?.isNoStipend}
            disabled={isReturnBoolean(
              roleFormData?.roleStatus,
              undefined,
              roleFormData?.republishedDate
            )}
          />
        </FormItem>
      )}
      {}
      {selectedType == 'INTERNSHIP' || selectedType == 'APPRENTICESHIP' ? (
        ''
      ) : (
        <>
        <FormItem
          name={['ctc', 'ctcType']}
          rules={[
            {
              required: false, // Check the flag
              message: 'Please enter the CTC Type',
            },
          ]}
        >
          {options?.map((item, index) => (
            <Checkbox
              onChange={e => {
                onChangeHandlerCTC(e.target.value, 'ctcType')
              }}
              checked={roleFormData?.ctc?.ctcType === item.value}
              label={item.label}
              key={index + item?.value}
              value={item.value}
              disabled={isReturnBoolean(
                roleFormData?.roleStatus,
                undefined,
                roleFormData?.republishedDate
              )}
            />
          ))}
        </FormItem>

        {roleFormData?.ctc?.ctcType === 'FIXED_VARIABLE'  && (
          <>
             <LabelDiv>Variable up to</LabelDiv>
        <Wrapper>

          <SelectInputDivision
            width="100%"
            borderleft={true}
            marginbottom={'15px'}
          >
            <CtcSelect
              bordered={false}
              defaultValue={'INR ₹'}
              disabled={true}
              filterOption={false}
              width="25%"
              style={{
                color: '#808697',
                fontSize: 'small',
              }}
            />
            <FormItem name={['ctc', 'variableAmount']}>
              <div>
                <Input
                  style={{
                    width: '100%',
                    height: '40px',
                    borderRadius: '0 8px 8px 0',
                  }}
                  onChange={e => {
                    onChangeHandlerCTC(e.target.value, 'variableAmount')
                    roleForm?.validateFields([['ctc', 'variableAmount']])
                  }}
                  placeholder="10,00,000"
                  value={roleFormData?.ctc?.variableAmount ?? ''}
                  disabled={isReturnBoolean(
                    roleFormData?.roleStatus,
                    undefined,
                    roleFormData?.republishedDate
                  )}
                />
              </div>
            </FormItem>
          </SelectInputDivision>
        </Wrapper>
        </>
      )}
        </>
      )}
      {selectedType == 'INTERNSHIP' || selectedType == 'APPRENTICESHIP' ? (
        ''
      ) : (
        <FormItem
          name={['ctc', 'isBond']}
          // rules={[
          //   {
          //     required: false, // Check the flag
          //     message: 'Please enter the bond type',
          //   },
          // ]}
        >
          <Checkbox
            onChange={event =>
              onChangeHandlerCTC(event.target.checked, 'isBond')
            }
            label={'Bond'}
            checked={roleFormData?.ctc?.isBond}
            disabled={isReturnBoolean(
              roleFormData?.roleStatus,
              undefined,
              roleFormData?.republishedDate
            )}
          />
        </FormItem>
      )}
      {roleFormData?.ctc?.isBond && (
        <FormItem
          name={['ctc', 'bondType']}
          // rules={[
          //   {
          //     required: roleFormData?.ctc?.isBond,
          //     message: 'Please enter the bond type',
          //   },
          // ]}
        >
          <TextAreas
            onChange={({ target }) => {
              onChangeHandlerCTC(target.value.trim() === '' ? '' : target.value, 'bondType')
            }}
            name={['ctc', 'bondType']}
            rows={4}
            maxLength={250}
            showCount
            rules={[
              {
                validator: (_, value) =>
                (value || '').trim() === ''
                  ? Promise.reject('Please add bond description')
                  : Promise.resolve(),
                required: true,
                message: 'Please add bond description',
              },
            ]}
            placeholder={'Add bond description'}
            disabled={isReturnBoolean(
              roleFormData?.roleStatus,
              undefined,
              roleFormData?.republishedDate
            )}
          />
        </FormItem>
      )}
      {}
      <FormItem
        name={['ctc', 'isAdditional']}
        rules={[
          {
            required: false,
            message: 'Please select range',
          },
        ]}
      >
        <Checkbox
          onChange={event =>
            onChangeHandlerCTC(event.target.checked, 'isAdditional')
          }
          label={'Additional Benefits'}
          checked={roleFormData?.ctc?.isAdditional}
          disabled={isReturnBoolean(
            roleFormData?.roleStatus,
            undefined,
            roleFormData?.republishedDate
          )}
        />
      </FormItem>
      {roleFormData?.ctc?.isAdditional && (
        <FormItem
          name={['ctc', 'additionalBenefits']}
          rules={[
            {
              required: roleFormData?.ctc?.isAdditional,
              message: 'Please enter description',
              validator: (_, value) => {
              const cleaned = (value || '').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim();
              return cleaned === ''
                ? Promise.reject('Please enter description')
                : Promise.resolve();
              },
            },
          ]}
        >
          <RichEditor
            labelName="Additional Benefits *"
            placeholder="Enter additional benefits here.."
            onChange={html => {
            const cleaned = html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim();
            // If there's content, ensure isAdditional stays true
            if (cleaned !== '') {
              setRoleFormData(prev => ({
                ...prev,
                ctc: {
                  ...prev.ctc,
                  isAdditional: true, // Keep checkbox checked
                  additionalBenefits: html
                }
              }));
              onChangeHandlerCTC(html, 'additionalBenefits');
            } else {
              onChangeHandlerCTC('', 'additionalBenefits');
            }
          }}
            value={
              roleFormData?.ctc?.additionalBenefits
                ? roleFormData?.ctc?.additionalBenefits
                : ''
            }
            setText={key}
            disabled={isReturnBoolean(
              roleFormData?.roleStatus,
              undefined,
              roleFormData?.republishedDate
            )}
          />
        </FormItem>
      )}

      {!roleFormData?.jobLocation?.isAnyWhere && (
        <FormItem
          name={['jobLocation', 'citiesIds']}
          rules={[
            {
              required:
                roleFormData?.jobDetails?.workStyle === 'REMOTE'
                  ? false
                  : !draft,
              message: 'Please select job location',
            },
          ]}
        >
          {loadLocation ? (
            <Spin
              tip="Loading Job Location..."
              size="small"
              style={{ display: 'flex', alignItems: 'center' }}
            />
          ) : (
            <Select
              showSearch={true}
              showArrow={true}
              OptionData={citiesList ?? []}
              label={
                roleFormData?.jobDetails?.workStyle === 'REMOTE'
                  ? 'Job Location'
                  : 'Job Location *'
              }
              valueParam="value"
              nameParam="name"
              placeholder="Enter Job Location"
              mode={'multiple'}
              onChange={(value, option) =>
                onLocationChange(value, 'cities', option)
              }
              onSearch={value => delaySaveToDb(value)}
              filterOption={false}
              selectedOptions={roleFormData?.jobLocation?.cities?.map(
                item => item?.id
              )}
              listHeight={170}
              disabled={isReturnBoolean(
                roleFormData?.roleStatus,
                undefined,
                roleFormData?.republishedDate
              )}
            />
          )}
        </FormItem>
      )}
      {!roleFormData?.jobLocation?.isAnyWhere &&
        notFoundedCityList?.length > 0 && (
          <div
            style={{ color: 'red', marginTop: '-5px', wordBreak: 'break-all' }}
          >
            No data matched for {notFoundedCityList.join(', ')}
          </div>
        )}
      <FormItem
        name={['isAnyWhere']}
        rules={[{ required: false, message: 'Please select job location' }]}
      >
        <Checkbox
          value={roleFormData?.jobLocation?.isAnyWhere}
          label={'Job Location Anywhere'}
          checked={roleFormData?.jobLocation?.isAnyWhere}
          onChange={handleCheckboxChange}
          disabled={isReturnBoolean(
            roleFormData?.roleStatus,
            undefined,
            roleFormData?.republishedDate
          ) || (roleFormData?.jobLocation?.citiesIds?.length > 0)}
        />
      </FormItem>
    </>
  )
}

export default StipendDetails
